/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Sandy_Moth_PeekInputs */

const en_pale_sandy_moth_peek = /** @type {(inputs: Pale_Sandy_Moth_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_pale_sandy_moth_peek = /** @type {(inputs: Pale_Sandy_Moth_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Pale_Sandy_Moth_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_sandy_moth_peek = /** @type {((inputs?: Pale_Sandy_Moth_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Sandy_Moth_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_sandy_moth_peek(inputs)
	return de_pale_sandy_moth_peek(inputs)
});